"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pwaServiceFactory = void 0;
var SERVICE_WORKER_PATH = '/sw.js';
var SERVICE_WORKER_SCOPE = '/';
var hasPwaSupport = function (win) {
    return typeof win.navigator !== 'undefined' && 'serviceWorker' in win.navigator;
};
function ensurePwaHeadTags(doc) {
    if (!(doc === null || doc === void 0 ? void 0 : doc.head)) {
        return;
    }
    if (!doc.querySelector('link[rel="manifest"]')) {
        var manifest = doc.createElement('link');
        manifest.rel = 'manifest';
        manifest.href = '/manifest.webmanifest';
        doc.head.appendChild(manifest);
    }
    if (!doc.querySelector('link[rel="apple-touch-icon"]')) {
        var icon = doc.createElement('link');
        icon.rel = 'apple-touch-icon';
        icon.href = '/icons/icon-192.png';
        doc.head.appendChild(icon);
    }
    if (!doc.querySelector('meta[name="theme-color"]')) {
        var theme = doc.createElement('meta');
        theme.name = 'theme-color';
        theme.content = '#222222';
        doc.head.appendChild(theme);
    }
    if (!doc.querySelector('meta[name="apple-mobile-web-app-title"]')) {
        var title = doc.createElement('meta');
        title.name = 'apple-mobile-web-app-title';
        title.content = 'Audroam';
        doc.head.appendChild(title);
    }
}
var PwaServiceImpl = /** @class */ (function () {
    function PwaServiceImpl($q, $window) {
        this.$q = $q;
        this.$window = $window;
        this.deferredInstallPrompt = null;
    }
    PwaServiceImpl.prototype.initialize = function ($rootScope) {
        return this.$q.when(this.initializeInternal($rootScope));
    };
    PwaServiceImpl.prototype.promptInstall = function () {
        return this.$q.when(this.promptInstallInternal());
    };
    PwaServiceImpl.prototype.initializeInternal = function ($rootScope) {
        return __awaiter(this, void 0, void 0, function () {
            var win, registration, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ensurePwaHeadTags(this.$window.document);
                        if (!hasPwaSupport(this.$window)) {
                            return [2 /*return*/, { supported: false, registered: false, installable: false, reason: 'unsupported' }];
                        }
                        win = this.$window;
                        win.addEventListener('beforeinstallprompt', function (event) {
                            event.preventDefault();
                            _this.deferredInstallPrompt = event;
                            $rootScope.$applyAsync(function () {
                                $rootScope.$broadcast('pwa:installable', { installable: true });
                            });
                        });
                        win.addEventListener('appinstalled', function () {
                            _this.deferredInstallPrompt = null;
                            $rootScope.$applyAsync(function () {
                                $rootScope.$broadcast('pwa:installed');
                            });
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.$window.navigator.serviceWorker.register(SERVICE_WORKER_PATH, {
                                scope: SERVICE_WORKER_SCOPE,
                            })];
                    case 2:
                        registration = _a.sent();
                        return [4 /*yield*/, registration.update()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, {
                                supported: true,
                                registered: true,
                                installable: !!this.deferredInstallPrompt,
                            }];
                    case 4:
                        error_1 = _a.sent();
                        console.warn('PWA service worker registration failed:', error_1);
                        return [2 /*return*/, {
                                supported: true,
                                registered: false,
                                installable: false,
                                reason: 'registration-failed',
                            }];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PwaServiceImpl.prototype.promptInstallInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promptEvent, choice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promptEvent = this.deferredInstallPrompt;
                        if (!promptEvent || typeof promptEvent.prompt !== 'function') {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, promptEvent.prompt()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, promptEvent.userChoice];
                    case 2:
                        choice = _a.sent();
                        if ((choice === null || choice === void 0 ? void 0 : choice.outcome) === 'accepted') {
                            this.deferredInstallPrompt = null;
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    return PwaServiceImpl;
}());
exports.pwaServiceFactory = [
    '$q',
    '$window',
    function ($q, $window) {
        return new PwaServiceImpl($q, $window);
    },
];
